import React from "react"
import {
   MentionSuggestionList
} from "./styles";
import MentionSuggestionEntry from "./MentionSuggestionEntry";

type PropType = {
  suggestedProfiles: any[],
  onMentionFocus: any,
  onMentionSelect: any
  focusedOptionIndex: number
}

export const SuggestionsView = (props: PropType) => {
    return (
      <>
        <MentionSuggestionList>
            {props.suggestedProfiles.map((mention, index) => (
                <MentionSuggestionEntry
                  index={index}
                  key={mention.id}
                  mention={mention}
                  onMentionFocus={props.onMentionFocus}
                  onMentionSelect={props.onMentionSelect}
                  isFocused={props.focusedOptionIndex === index}
                />
              ))}
            </MentionSuggestionList>
            </>
    )
}